import type { ReactNode } from 'react';
import { Card, Divider, Typography } from '@mui/material';

type PreviewSectionCardProps = {
    title: string;
    children: ReactNode;
};

const PreviewSectionCard = ({ title, children }: PreviewSectionCardProps) => {
    return (
        <Card variant="outlined" sx={{ p: 3 }}>
            <Typography variant="subtitle1" fontWeight={600}>
                {title}
            </Typography>
            <Divider sx={{ my: 2 }} />
            {children}
        </Card>
    );
};

export default PreviewSectionCard;
